import * as React from "react"
import { t } from 'i18next'
import { Pager } from "../../drupal/types_and_parser/extra_types.mod"

type PaginationState = {}
type PaginationProps = {
  pager: Pager
  setPage: (page: number) => void
}

export class Pagination extends React.Component<PaginationProps, PaginationState> {

  constructor(props) {
    super(props)
  }

  render() {
    let paginationNumbers = [];

    for (let pageNumber = this.props.pager.current_page - 4; pageNumber < this.props.pager.current_page + 5; pageNumber++) {
      if (pageNumber == this.props.pager.current_page)
        paginationNumbers.push(<li className="pagination__item pagination__item--pages pagination__item--current" key={`page-${pageNumber}`}><span className="pagination__link">{pageNumber + 1}</span></li>);
      else if (pageNumber >= 0 && pageNumber < this.props.pager.total_pages)
        paginationNumbers.push(<li className="pagination__item pagination__item--pages" key={`page-${pageNumber}`}><a className="pagination__link" onClick={() => this.props.setPage(pageNumber)}>{pageNumber + 1}</a></li>)
    }
  
    return this.props.pager.total_pages > 1 ? (

      <nav className="pagination container container--m grid--gutter">
        <div className="pagination__inner">
          <ul className="pagination__list">
              
            {this.props.pager.current_page > 0 ?
              <li className="pagination__item pagination__item--prev">
                <button className="pagination__button pagination__button--prev" onClick={() => this.props.setPage(this.props.pager.current_page -1)}>{ t('pagination.previous') }</button>
              </li>
            : <li className="pagination__item pagination__item--prev">
               <button className="pagination__button pagination__button--prev" disabled>{ t('pagination.previous') }</button>
              </li> }
              <li>
                <ul>
                {this.props.pager.current_page > 4 ? 
                  <li className="pagination__item pagination__item--pages">
                    <button className="pagination__button" onClick={() => this.props.setPage(0)}>1</button>
                  </li>
                : null }

                {this.props.pager.current_page > 5 ? 
                  <li className="pagination__item pagination__item--pages pagination__item--spacer">...</li> 
                : null }

                {paginationNumbers}

                {this.props.pager.current_page < this.props.pager.total_pages - 6 ? 
                  <li className="pagination__item pagination__item--pages pagination__item--spacer">...</li> 
                : null }
                {this.props.pager.current_page < this.props.pager.total_pages - 5 ?
                  <li className="pagination__item pagination__item--pages">
                    <button className="pagination__link" onClick={() => this.props.setPage(this.props.pager.total_pages - 1)}>{this.props.pager.total_pages}</button>
                  </li>
                : null }
                </ul>
              </li>
            {this.props.pager.current_page < this.props.pager.total_pages - 1 ?
              <li className="pagination__item pagination__item--next">
                <button className="pagination__button pagination__button--next" onClick={() => this.props.setPage(this.props.pager.current_page + 1)}>{ t('pagination.next') }</button>
              </li>
            : <li className="pagination__item pagination__item--next">
                <button className="pagination__button pagination__button--next" disabled>{ t('pagination.next') }</button>
              </li> } 
         </ul>
        </div>
      </nav>
    ) : null
  }
}
